export const parseAttributes = (attributes) => {
  const dataAttributes = {};
  if (attributes) {
    const attrs = attributes.split(',');
    attrs.forEach((attr) => {
      const attrData = attr.split('=');
      if (attrData && attrData.length > 1) {
        const attribute = attrData[0].trim();
        const value = attrData[1].trim();
        dataAttributes[attribute] = value;
      }
    });
  }
  return dataAttributes;
};

export const openEasyQuiz = () => {
  window.PGWidgets.actions.openLifeCoverageTermQuiz();
};



// WEBPACK FOOTER //
// ../src/contentfulPages/components/CTA/utils.js